import { POSTUpdateSettingsReqBody, UserTraitsResponse } from '@myme/api/src/kratos';
import { handleVerifyUser } from '@myme/logic/src/kratos';
import { kratosIntegration } from '@myme/utils';
import { KratosInitFlow } from '../../types';

export const handleUpdateProfile = async (flow: KratosInitFlow, data: POSTUpdateSettingsReqBody) => {
  const user = await handleVerifyUser();

  const traits: UserTraitsResponse = {
    ...user.data.identity.traits,
    ...data
  };

  const overrideReqBody = {
    csrf_token: flow.csfrToken,
    method: 'profile',
    traits
  };

  await kratosIntegration.request.submitSelfServiceSettingsFlow(flow.flowId, undefined, overrideReqBody);

  return traits;
};
